import { useGetWithRefetch } from '../../../hooks/useFetchEndPoint';
import { StudyGroup } from './api/types';

export const useGetStudyGroup = (pk?: string | null) => {
  return useGetWithRefetch<StudyGroup>(`/api/v1/records/study_groups/${pk}/`, {
    running: !!pk,
  });
};
